import { PocTooltip } from 'commons/components/components-wrapper';
import { StyledTooltipedText } from 'commons/components/tooltiped-text';
import { useAsyncTooltipMount } from 'commons/hooks';
import React from 'react';

interface SearchableDropdownOptionTextProps {
    /** Option label with the search matches highlighted. */
    label: React.ReactNode;
    /** Plain full text shown in the tooltip when the label is truncated. */
    tooltipText: string;
    slot?: string;
}

export const SearchableDropdownOptionText: React.FC<SearchableDropdownOptionTextProps> = ({
    label,
    tooltipText,
    slot,
}) => {
    const { tooltipAnchorId, isMountedTooltip, isVisibleTooltip, onMouseEnter, onMouseLeave } = useAsyncTooltipMount({
        shouldShowTooltip: (ev) => ev.currentTarget.scrollWidth > ev.currentTarget.clientWidth,
    });

    return (
        <StyledTooltipedText id={tooltipAnchorId} slot={slot} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <span>{label}</span>
            {isMountedTooltip ? (
                <PocTooltip
                    anchor={tooltipAnchorId}
                    strategy="fixed"
                    placement="bottom"
                    disableTriggers
                    visible={isVisibleTooltip}
                >
                    {tooltipText}
                </PocTooltip>
            ) : null}
        </StyledTooltipedText>
    );
};
